import React from 'react'
import UGCItem from './ugc-item'
import classNames from 'classnames'
interface ITopLabelProps {
  className?: string
}

export const TopLabel: React.FC<ITopLabelProps> = ({ className, children }) => {
  return (
    <span
      className={classNames(
        'tw-text-12 tw-text-common-blue tw-inline-block tw-align-text-bottom tw-w-36 tw-h-24 tw-leading-24 tw-text-center tw-rounded-2',
        className
      )}
    >
      {children}
    </span>
  )
}

interface IProps {
  data?: any
  announcements?: any
  teaParams?: Record<string, string>
  sort?: string
}

const Content: React.FC<IProps> = ({
  data,
  announcements,
  teaParams,
  sort,
}) => {
  const announcementList = announcements?.announcement_list || []

  return (
    <React.Fragment>
      {/* {announcementList.length ? (
        <div className="tw-bg-white tw-px-24 tw-py-20 tw-mt-16">
          {announcementList.map((item: any, index: number) => {
            return (
              <React.Fragment key={index}>
                {anyLink({
                  id: item.gid_str,
                  articleType: item.article_type,
                })(
                  <div
                    className={classNames('tw-flex tw-item-center', {
                      'tw-mt-6': index,
                    })}
                  >
                    <TopLabel className="tw-bg-common-blue tw-bg-opacity-10 tw-flex-none">
                      {item.header}
                    </TopLabel>

                    <p
                      className={classNames(
                        'tw-ml-12 tw-flex-auto line-1 tw-leading-24',
                        size14Class
                      )}
                    >
                      {item.content}
                    </p>
                    <i className="tw-flex-none DCD_Icon icon_PC-triangle tw-ml-24" />
                  </div>
                )}
              </React.Fragment>
            )
          })}
        </div>
      ) : null} */}
      {data?.cheyou_list?.map((item: any) => {
        return (
          <UGCItem
            key={item.gid_str}
            data={item}
            teaParams={teaParams}
            sort={sort}
          />
        )
      })}
    </React.Fragment>
  )
}

export default Content
